"use client";

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import { POP_MOVIES_QUERY } from "src/components/popularmovieslist/popularMoviesQuery";
import PosterRow from 'src/components/posterrow/PosterRow';
import type { Movie } from 'src/lib/movieinfo/movieinfotypes';
import styles from './PopularMoviesList.module.css';
import { useFilminfo } from "src/lib/client/useFilminfo";
import { locale } from "@locale";

//#region [Props]
type PopularMoviesListProps = {
  hideHeader?: boolean;
  className?: string;
  posterRowClassName?: string;
  hideWatchlistMobile?: boolean;
  hideWatchlistDesktop?: boolean;
  filterMoviesOnFomId?: string[];
  max?: number;
};
//#endregion

// MAYBE: This could be a server component? This would reduce the load on movieInfoQs
//#region [Component]
export default function PopularMoviesList(t0) {
  const $ = _c(23);
  const {
    className,
    posterRowClassName,
    hideHeader: t1,
    hideWatchlistMobile: t2,
    hideWatchlistDesktop: t3,
    filterMoviesOnFomId,
    max
  } = t0;
  const hideHeader = t1 === undefined ? false : t1;
  const hideWatchlistMobile = t2 === undefined ? false : t2;
  const hideWatchlistDesktop = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      staleTime: 3300000
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    fiLoading,
    fiData
  } = useFilminfo(POP_MOVIES_QUERY, undefined, t4);
  let t5;
  if ($[1] !== fiData?.movieQuery?.getPopularMovies || $[2] !== filterMoviesOnFomId) {
    t5 = (filterMoviesOnFomId?.length ?? 0) > 0 ? (fiData?.movieQuery?.getPopularMovies as (undefined | null | Movie[]))?.filter(m => !m.mainVersionId || !filterMoviesOnFomId?.includes(m.mainVersionId)) : fiData?.movieQuery?.getPopularMovies;
    $[1] = fiData?.movieQuery?.getPopularMovies;
    $[2] = filterMoviesOnFomId;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const filtered = t5;
  let t6;
  if ($[4] !== className) {
    t6 = classNames(styles.SPopularMoviesList, className);
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== hideHeader) {
    t7 = !hideHeader && <h2 className={styles.SPopMoviesHeader}>{locale.popularMoviesList.label}</h2>;
    $[6] = hideHeader;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== fiLoading) {
    t8 = fiLoading && <LoadingIndicator position="InlineCenter" />;
    $[8] = fiLoading;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== fiLoading || $[11] !== filtered || $[12] !== hideHeader || $[13] !== hideWatchlistDesktop || $[14] !== hideWatchlistMobile || $[15] !== max || $[16] !== posterRowClassName) {
    t9 = !fiLoading && <PosterRow className={posterRowClassName} posterList={filtered as (undefined | null | Movie[])} headerLevel={hideHeader ? 2 : 3} hideWatchlistMobile={hideWatchlistMobile} hideWatchlistDesktop={hideWatchlistDesktop} max={max} />;
    $[10] = fiLoading;
    $[11] = filtered;
    $[12] = hideHeader;
    $[13] = hideWatchlistDesktop;
    $[14] = hideWatchlistMobile;
    $[15] = max;
    $[16] = posterRowClassName;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <aside className={t6}>{t7}{t8}{t9}</aside>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
//#endregion